import { render, staticRenderFns } from "./SwitchDarkMode.vue?vue&type=template&id=46738b9f&scoped=true"
import script from "./SwitchDarkMode.vue?vue&type=script&lang=js"
export * from "./SwitchDarkMode.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "46738b9f",
  null
  
)

export default component.exports